<template>
    <div class="tq-aside-menu-wrap" @mouseleave="mouseLeaveWrap">
      <div class="tq-aside-menu-item" v-for="item in (menus as any)" :key="item.slotKey" @mouseover="mouseOnItem(item)">
        <div class="left-label">
          <span>{{ item.label }}</span>
        </div>
        <div class="right-arrow">
          <i class="el-icon-arrow-right"></i>
        </div>
      </div>
      <div class="absolute-content-area" v-show="canShowContentArea">
        <div class="area-item" v-for="item in (menus as any)" :key="item.slotKey" v-show="item.slotKey === currentItem.slotKey">
          <slot :name="item.slotKey"></slot>
        </div>
      </div>
    </div>
</template>

<script lang="ts">
export default {
    name: 'TqAsideMenu',
    props: {
        menus: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
          currentItem: {
            slotKey: '',
            label: ''
          },
          canShowContentArea: false
        }
    },
    methods: {
      mouseOnItem(item:any) {
        this.canShowContentArea = true;
        this.currentItem = {...item}
      },
      mouseLeaveWrap() {
        console.log('mouseLeaveWrap');
        this.canShowContentArea = false;
      }
    }
}
</script>
